import{getDefaultExportFromCjs as o}from"./_commonjsHelpers.mjs";import{__require as r}from"../us_autocomplete_pro/Suggestion.mjs";var e=o(r());export{e as default};
